"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useAlreadyInsuredNewCarCheck_1 = require("./useAlreadyInsuredNewCarCheck");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return useAlreadyInsuredNewCarCheck_1.default; } });
//# sourceMappingURL=index.js.map